export enum Degree {
	BSC = 'BSc',
	MSC = 'MSc',
	PHD = 'PhD'
}
